import { SET_GENRES, SET_GENRES_YEARS } from "@/store/mutation-types";

export default {
  [SET_GENRES](state, genres = []) {
    state.genres = {
      ...state.genres,
      ...genres.reduce((map, genre) => ({ ...map, [genre.id]: genre }), {})
    };
  },
  [SET_GENRES_YEARS](state, { genreId, years = [] }) {
    state.years = {
      ...state.years,
      [genreId]: years
    };
  }
};
